export const defaultUnitDefaultMock = 'Default Unit';

export const defaultUnitsMock = [
  'Value',
  'Value in bp of NAV',
  'Value in bp of PV',
  'Value in % of NAV',
  'Value in % of PV',
];
